import { useRef, useState, useEffect, FC, Children, isValidElement, cloneElement } from 'react';
import { useMapListeners } from './useMapListeners';

interface MapProps extends google.maps.MapOptions {
  style?: { [key: string]: string | number };
  initialZoom: number;
}

export const Map: FC<MapProps> = ({ children, style, center, fullscreenControl, streetViewControl, initialZoom }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map>();
  const [zoom] = useState(initialZoom);

  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current));
    }
  }, [map, ref]);

  useEffect(() => {
    if (!map) return;
    map.setOptions({
      ...(center?.lat && center?.lng ? { center } : {}),
      fullscreenControl,
      streetViewControl,
      zoom,
      tilt: 0,
    });
  }, [map, fullscreenControl, streetViewControl, zoom, center]);

  useMapListeners(map);

  return (
    <>
      <div ref={ref} style={style} />
      {Children.map(children, child =>
        isValidElement<{ map: google.maps.Map }>(child) ? cloneElement(child, { map }) : null,
      )}
    </>
  );
};
